// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend_MumTJ","title":"index_title_9-D0v","list_box":"index_list_box_ruD82","more":"index_more_6jISP"};